import * as React from "react";

const GoogleDriveIcon = ({className = " "}: {className: string}) => (     
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
    className={className}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M12 13.325v3m0 0a2 2 0 0 1 2 2m-2-2a2 2 0 0 0-2 2m0 0a2 2 0 0 0 4 0m-4 0H3m11 0h7M5 10.222c0-1.714 1.46-3.104 3.26-3.104.275-1.22 1.255-2.215 2.572-2.61 1.317-.398 2.77-.135 3.811.69 1.042.821 1.514 2.08 1.239 3.3h.693A2.42 2.42 0 0 1 19 10.91a2.42 2.42 0 0 1-2.425 2.414H8.26c-1.8 0-3.26-1.39-3.26-3.103"
    ></path>
  </svg>
);

export default GoogleDriveIcon;
